import UniversalCookie from "universal-cookie";

const SITE_EXPIRATION = 7 * 24 * 60 * 60 * 1000 // 7 days
const SESSION_EXPIRATION = 1 * 24 * 60 * 60 * 1000 // 1 day
const EXPIRATION_UPTATE = 5 * 60 * 1000 // 5 minutes

const universalCookie = new UniversalCookie(null, {
  path: '/',
  domain: 'userenroll.com',
  sameSite: 'lax',
})

let lastExpirationUpdate = 0

export default class CookieHelper {
  static clear(key) {
    universalCookie.remove(`pe_${key}`)
  }

  static clearSession() {
    this.clear('session')
    this.clearSite()
  }

  static clearSite() {
    this.clear('site')
  }

  static setCookie(key, value, expires) {
    universalCookie.set(`pe_${key}`, value, { expires })
  }

  static setSessionId(session) {
    const { session_id } = session || {}
    if (!session_id) {
      return;
    }
    this.setCookie('session', session_id, new Date(Date.now() + SESSION_EXPIRATION))
    lastExpirationUpdate = Date.now()
  }

  static setSiteId(siteId) {
    this.setCookie('site', siteId, new Date(Date.now() + SITE_EXPIRATION))
  }

  static getCookie(key) {
    const value = universalCookie.get(`pe_${key}`)
    return value || null
  }

  static getSessionId() {
    return this.getCookie('session')
  }

  static getSiteId() {
    return this.getCookie('site')
  }

  static updateSessionExpiration() {
    try {
      if (Date.now() - lastExpirationUpdate < EXPIRATION_UPTATE) {
        return;
      }

      const session_id = this.getSessionId()
      this.setSessionId({ session_id })
    } catch (error) {
      return;
    }
  }
}
